import { connect } from 'react-redux';

import API from '@api';
import config from '@config';
import { setChannels, addChannels } from '@store/actions/channels';
import { getCookie } from '@themejs/helpers/cookies';
import { addPrograms } from '@search/store/actions/programs';
import { clearResults } from '@search/store/actions/results';
import App from './app';

const locationHost = window.location.host;

if (locationHost.indexOf('freely') > -1) {
  config.defaultNID = config.searchDefaultNID;
}

const mapDispatchToPros = dispatch => ({
  getData: () => {
    const nid = getCookie(config.cookies.nidCookieName) || config.defaultNID;
    API.getChannels(nid)
      .then(channels => {
        dispatch(setChannels(channels));
        return;
      })
      .then(() => {
        return API.getMobileOwningServices();
      })
      .then(services => {
        dispatch(addChannels(services));
        return;
      })
      .then(() => {
        return API.getWhatsOn(nid);
      })
      .then(programs => {
        dispatch(
          addPrograms(
            programs.map(p => {
              return {
                ...p,
                type: 'tvguide',
              };
            }),
          ),
        );
        return;
      })
      .then(() => {
        return API.getProgramRecommendations(
          'crid://digitaluk.co.uk/recommendations/categories/all',
          nid,
        );
      })
      .then(programs => {
        dispatch(
          addPrograms(
            programs.map(p => {
              return { ...p, type: 'recommendations' };
            }),
          ),
        );
      })
      .catch(error => {
        console.error(error);
      });
  },
  clearSearch: () => {
    dispatch(clearResults());
  },
});

export default connect(null, mapDispatchToPros)(App);
